<template>
  <v-icon dense :color="colorOverride ? colorOverride : (completed ? primaryColor : ( optional ? accentColor : errorColor))" class="pr-2">
    {{completed ? 'check_box' : (indeterminate ? 'indeterminate_check_box' : 'check_box_outline_blank')}}
  </v-icon>
</template>

<script>
  export default {
    name: "CompletedIcon",
    data() {
      return {
        primaryColor: process.env.VUE_APP_COLOR_PRIMARY,
        accentColor: process.env.VUE_APP_COLOR_ACCENT,
        errorColor: process.env.VUE_APP_COLOR_ERROR
      }
    },
    props: {
      completed: {
        type: Boolean,
        default: false
      },
      optional: {
        type: Boolean,
        default: false
      },
      indeterminate: {
        type: Boolean,
        default: false
      },
      colorOverride: {
        type: String,
        default: null
      }
    }
  }
</script>

<style scoped>

</style>